import { render, staticRenderFns } from "./PropertyDetailsCard.vue?vue&type=template&id=9f081744&scoped=true&"
import script from "./PropertyDetailsCard.vue?vue&type=script&lang=js&"
export * from "./PropertyDetailsCard.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetailsCard.vue?vue&type=style&index=0&id=9f081744&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f081744",
  null
  
)

export default component.exports